export default __webpack_public_path__ + "static/media/Shard of Tartaros (intelligence).30524877.jpg";